import { definition } from '@fortawesome/free-solid-svg-icons/faPoundSign';
import React, { Component } from 'react'
import CustomFieldValue from "../common/custom-field/value.component.jsx";


class CustomFieldRendering extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            isEditable:this.props.isEditable
        }
    }

    getDefinitions() {
        let customFieldValues = Object.assign({}, this.props.customFieldValues)
        for (let definition of this.props.customFieldDefinitions) {
            if (!this.props.customFieldValues[definition.id]) {
                customFieldValues[definition.id] = ""
            }
        }
        return customFieldValues
    }

    getValueByDefinitionId(definitionId, fieldType) {
        if (!this.props.customFieldValues) {
            return ''
        }
        let definitions = this.getDefinitions()
      
        for (let id in definitions) {
            if (id === definitionId) {
                return (this.props.customFieldValues[id] || this.state.isEditable) ?
                    <CustomFieldValue
                        definitionId={definitionId}
                        value={this.props.customFieldValues[id]}
                        editable={this.state.isEditable}
                        elementId={this.props.elementId}
                        element={this.props.element}
                        onChange={(value) => this.props.changeCustomFieldValues(value, id)}
                    /> : ''
            }
        }
        return ''
    }

    renderFieldColumn(definitionId, colClass, labelFormattedMessage, value) {
        return <div key={definitionId} className={'position-relative mt-2 px-1 text-break mb-2 ' + colClass}>
            <div className={'py-1 px-2 h-100 inline-input'}>
                {labelFormattedMessage ?
                    <div>
                        <label className="col-form-label custom-form-label project-details-label pt-0">
                            {labelFormattedMessage}
                        </label>
                    </div> : ''
                }
                <div>
                    {value}
                </div>
            </div>
        </div>
    }
    
    render() {
        return this.props.customFieldDefinitions
        .filter((_, index) => {
            const nbPerCol = Math.ceil(this.props.customFieldDefinitions.length / 2)
            if (this.props.col === 0) {
                return index < nbPerCol
            } else {
                return index >= nbPerCol
            }
        })
        .map(definition => {
            const value = this.getValueByDefinitionId(definition.id, definition.attributes.fieldType)
            if (!value) {
                return <div key={definition.id} />
            }

            let widthClass = 'col-lg-3 col-md-4'
            if (['text', 'multi-line-text', 'image'].includes(definition.attributes.fieldType)) {
                widthClass = 'col-lg-6 col-md-8'
            }

            return this.renderFieldColumn(
                definition.id,
                widthClass,
                definition.attributes.name,
                <span>{value}</span>
            )
        })
    }
}

export default CustomFieldRendering


// WEBPACK FOOTER //
// ./src/custom-field/rendering.component.jsx